<template>
  <div>
    <v-dialog :value="edit" v-if="edit != null" width="90%">
      <v-card>
        <v-card-title class="headline">
          {{ isAdding ? "Ajout d'un modèle" : `Modification du modèle` }}
        </v-card-title>
        <v-card-text v-if="!isAdding">
          <p><strong>ATTENTION !</strong></p>
          <p>
            Vous pouvez modifier le nom du modèle, pour autant, cette
            modification ne s'appliquera qu'aux futures signatures.
          </p>
        </v-card-text>
        <v-card-text>
          <v-text-field
            v-model="edit.name"
            data-vv-name="name"
            :error-messages="errors.collect('name')"
            label="Name"
          />
          <v-select
            :items="signatureSteps"
            data-vv-name="step"
            v-model="edit.step"
            label="Étape"
          />
          <v-layout row class="align-center ml-2 mr-2">
            <v-flex xs12 md6 class="d-flex d-flex-initial">
              <v-switch
                v-model="edit.hasCoRequester"
                :label="`Ce document doit-il être signé par un éventuel co-demandeur ?`"
              ></v-switch>
            </v-flex>
            <v-flex xs12 md6 class="d-flex d-flex-initial">
              <v-switch
                v-if="!isAdding"
                v-model="edit.active"
                :label="`Ce modèle est : ${edit && edit.active ? 'actif' : 'désactivé'}`"
              ></v-switch>
            </v-flex>
          </v-layout>
          <v-layout row class="align-center ml-2 mr-2" v-if="isAdding">
            <v-flex xs12 md6 class="d-flex d-flex-initial">
              <v-radio-group v-model="edit.documentType">
                <v-radio
                  v-for="type in documentTypes"
                  :key="type.value"
                  :label="type.label"
                  :value="type.value"
                ></v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-text v-if="isAdding">
          <input
            type="file"
            id="templateFile"
            ref="templateFile"
            accept="application/pdf"
            @change="selectFiles"
          />
        </v-card-text>
        <v-card-actions>
          <v-btn flat @click="edit = null" color="grey">Annuler</v-btn>
          <v-btn flat @click="save()" :disabled="!this.file && this.isAdding" color="green">Valider</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog :value="templateUrl" v-if="templateUrl !== null" id="contralia-edit-template-dialog" width="90%" height="90%" top="5%" left="5%">
      <v-card>
        <div style="overflow: scroll; -webkit-overflow-scrolling: touch;">
          <iframe :src=templateUrl title="Modifier le modèle" width="100%" height="700px"></iframe>
        </div>
      </v-card>
      <v-card-actions>
        <v-btn flat @click="templateUrl = null" color="grey">Fermer</v-btn>
      </v-card-actions>
    </v-dialog>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="signatureTemplates.items"
        class="signature-step-documents-table"
        :rows-per-page-items="[100, 200]"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.name }}</td>
          <td>{{ getSignatureStep(props.item.step) }}</td>
          <td>{{ props.item.documentId }}</td>
          <td>
            <v-icon v-if="props.item.active">check</v-icon>
            <v-icon v-else>cancel</v-icon>
          </td>
          <td>
            <v-icon v-if="props.item.hasCoRequester">check</v-icon>
            <v-icon v-else>cancel</v-icon>
          </td>
          <td>
            <v-btn icon @click="editTemplate(props.item)">
              <v-icon>file_open</v-icon>
            </v-btn>
            <v-btn icon @click="editItem(props.item)">
              <v-icon>edit</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
      <v-snackbar v-model="showError" :timeout="7000"
        >Une erreur a eu lieu</v-snackbar
      >
    </v-card>
    <div style="position: sticky; bottom: 0; width: 100%">
      <v-btn
        class="hil-fab"
        dark
        fab
        color="accent"
        @click="edit = {}"
        style="position: absolute; right: 0"
      >
        <v-icon>add</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { fetchHil } from "../../../utils";
import { mapActions, mapState } from "vuex";
import { SIGNATURE_STEPS } from "../../../../../webapp-commons/data";

export default {
  components: {},
  data() {
    return {
      isAdding: true,
      edit: null,
      file: null,
      showError: false,
      signatureSteps: SIGNATURE_STEPS,
      templateUrl: null,
      documentTypes: [
        {
          value: "engagementLetter",
          label: "Lettre de mission"
        },
        {
          value: "mobilipass",
          label: "Dossier mobilipass"
        },
        {
          value: "endOfMissionReport",
          label: "Rapport de fin de mission"
        },
        {
          value: "other",
          label: "Autre"
        },
      ],
      headers: [
        {
          text: "Nom du modèle",
          value: "name"
        },
        {
          text: "Étape à laquelle le fichier sera présenté",
          value: "step"
        },
        {
          text: "ID du modèle chez Contralia",
          value: "documentId"
        },
        {
          text: "Actif",
          value: "active"
        },
        {
          text: "Doit être signé par un co-demandeur",
          value: "hasCoRequester"
        },
        {
          text: "",
          sortable: false
        }
      ]
    };
  },
  mounted() {
    this.refreshSignatureSteps();
  },
  computed: {
    ...mapState("signatureTemplates", ["signatureTemplates"])
  },
  methods: {
    ...mapActions("signatureTemplates", ["fetchSignatureTemplates"]),

    refreshSignatureSteps() {
      return this.fetchSignatureTemplates();
    },

    editItem(item) {
      this.edit = item;
      this.isAdding = false;
    },

    async save() {
      if (!(await this.$validator.validate())) {
        return;
      }

      const { name, step, hasCoRequester, active, documentType } = this.edit;

      let resp;
      if (this.isAdding) {
        const formData = new FormData();
        formData.append("name", name);
        formData.append("step", step);
        formData.append("documentType", documentType);
        formData.append("hasCoRequester", hasCoRequester || false);
        formData.append("file", this.file);

        resp = await fetchHil(`/signature-templates`, {
          method: "POST",
          body: formData
        });
      } else {
        resp = await fetchHil(`/signature-templates/${this.edit._id}`, {
          method: "PUT",
          body: {
            name,
            step,
            hasCoRequester,
            active
          }
        });
      }

      if (!resp.ok) {
        this.showError = true;
        return;
      }

      this.edit = null;
      this.isAdding = true;
      this.refreshSignatureSteps();
    },
    selectFiles(e) {
      const selectedFile = e.target.files[0];
      if (selectedFile.type !== "application/pdf") {
        alert("Seuls les fichiers PDF sont acceptés");
      }
      if (selectedFile.size > 10000000) {
        alert("Votre fichier ne doit pas faire plus de 10Mo");
      }
      this.file = selectedFile;
    },
    getSignatureStep(value) {
      const currentStep = SIGNATURE_STEPS.find(step => step.value === value);
      return currentStep.text;
    },
    async editTemplate(item) {
      let resp;
      try {
        resp = await fetchHil(`/signature-templates/${item._id}/update-template-edition-url`, { method: "GET" });
      } catch (e) {
        this.showError = true;
        console.log(e);
        return;
      }

      const data = await resp.json();
      this.templateUrl = data.url;
    }
  }
};
</script>

<style></style>
